var exports = {
  "iE": "xaee3c4fa--789ead--wrapper",
  "rU": "xaee3c4fa--789ead--iframe-wrapper",
  "kZ": "xaee3c4fa--789ead--image-wrapper",
  "dM": "xaee3c4fa--789ead--background-image",
  "x6": "xaee3c4fa--789ead--button",
};

module.exports = exports;
